import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-table',
  standalone: true,
  template: `
    <div class="cg-table-wrap">
      <table class="cg-table">
        <ng-content />
      </table>
    </div>
  `,
})
export class AdminTableComponent {}
